module.exports = __webpack_public_path__ + "static/img/case-mobile-diagram-05.1374ba5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/case-mobile-diagram-05.png
// module id = mDx2
// module chunks = 1